import React from 'react';
import {connect} from "react-redux";
import Dialog from 'material-ui/Dialog';
import {closePDFViewer} from "../../../actions/shared/actions_shared_1";


class PDFViewer extends React.Component {

    render() {
        const height = isNaN(window.innerHeight) ? window.clientHeight : window.innerHeight;
        return (
            <Dialog
                open={this.props.open}
                contentStyle={{width:'100%', maxWidth:'none', minHeight:'100%', maxHeight:'none'}}
                onRequestClose={()=>this.props.dispatch(closePDFViewer())}
                >
                <object aria-label='pdf' height={(height - 150)+'px'} width='100%' data={this.props.data} type='application/pdf'></object>
            </Dialog>
        );
    }
}

function mapStateToProps(store) {
    return {open: store.shared.pdf_viewer.open, data: store.shared.pdf_viewer.data}
}

export default connect(mapStateToProps)(PDFViewer);


// WEBPACK FOOTER //
// ./src/components/shared/utils/PDFViewer.js